import { Injectable, Injector } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { SiAuthenticationService } from '@strategic-insights/ng-authentication';
import { Router } from '@angular/router';
import { Observable, throwError } from 'rxjs';
import { tap } from 'rxjs/operators';
import { CookieService } from 'ngx-cookie';
import { AppService } from './app.service';
declare let $;

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
    appLoaderCounter = 0;
    constructor(private injector: Injector, private router: Router,
        private cookieService: CookieService, private appService: AppService) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        this.appLoaderCounter++;
        this.setLoaderStatus();
        // IMPORTANT: AuthService needs to be injected using injector to avoid cyclic dependency
        const siAuthenticationService = this.injector.get(SiAuthenticationService);
        const httpHeaders = {
            username: siAuthenticationService.getUser(),
            // version: 'RELEASE_VERSION',
            authtype: siAuthenticationService.getAuthType() || 'nonsso'
        };
        if (siAuthenticationService.getAuthToken()) {
            httpHeaders['authtoken'] = siAuthenticationService.getAuthToken();
        }
        if (siAuthenticationService.getWebToken()) {
            httpHeaders['webtoken'] = siAuthenticationService.getWebToken();
        }
        if (siAuthenticationService.getActiveCustomer()) {
          let activeCustomer = siAuthenticationService.getActiveCustomer();
          httpHeaders["orgname"] = activeCustomer;
        }
        if(this.cookieService.get("pac4jCsrfToken")){
          httpHeaders["pac4jCsrfToken"] = this.cookieService.get("pac4jCsrfToken");
        }
        if (siAuthenticationService.getWebToken() || siAuthenticationService.getAuthToken()) {
            request = request.clone({
                setHeaders: httpHeaders
            });
        }

        return next.handle(request).pipe(
            tap(event => {
                if (event instanceof HttpResponse) {
                    this.appLoaderCounter--;
                    this.setLoaderStatus();
                    return event;
                }
            }, error => {
                console.log('Error : ', error);
                if (error instanceof HttpErrorResponse) {
                    this.appLoaderCounter--;
                    this.setLoaderStatus();
                    if (error.status === 403 || error.status === 401) {
                        if (siAuthenticationService.isSSO()) {
                            // delete auth token only
                            if (siAuthenticationService.getAuthToken()) {
                                this.cookieService.remove('authtoken', { domain: window.location.host });
                            }
                            if (siAuthenticationService.getWebToken()) {
                                this.cookieService.remove('webtoken', { domain: window.location.host });
                            }
                        } else {
                            siAuthenticationService.deleteAPIResponse();
                            this.appService.tokenExpireStatus.next(true);
                            this.router.navigate(['/kclogoutredirect'], { queryParams: {logout : true}});
                        }
                        return throwError(error);
                    }
                    return throwError(error);
                }
            })
        );
    }
    setLoaderStatus() {
        if (this.appLoaderCounter && !this.appService.appBlocker.getValue()) {
            this.appService.appBlocker.next(true);
        } else if (!this.appLoaderCounter) {
            this.appService.appBlocker.next(false);
        }
    }
}
